export const baseURL = "https://portal.nawarliveapp.top/";
export const key = "AauCc3J0rXzqlqJvJkLMzg";
export const projectName = "Nawar Live"
